<template>
  <div
    v-editable="blok && !blok.isGlobal && icon"
    class="flex h-full w-full place-items-center lg:flex-col"
  >
    <div class="ml-2 md:ml-0">
      <RawSvgIcon
        v-if="icon.icon"
        :svg="icon.icon"
        :classes="sizeClasses"
        :color="iconColor"
        class="mx-auto"
      />
    </div>
    <div
      class="prose prose-lg prose-blue ml-6 font-content lg:ml-0 lg:mt-4 lg:text-center"
      :class="textColorClass(blok.textVariant, blok.bgVariant)"
    >
      <span>{{ icon.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import RawSvgIcon from './RawSvgIcon.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  icon: {
    type: Object,
    default: () => {},
  },
  iconColor: {
    type: String,
    default: '',
  },
  blok: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass } = useColorPalette()

const sizeClasses = computed(() => {
  const classes = {
    xs: 'w-10 h-10 md:w-4 md:h-4',
    sm: 'w-10 h-10 md:w-6 md:h-6',
    md: 'w-10 h-10 md:w-10 md:h-10',
    lg: 'w-10 h-10 md:w-14 md:h-14',
    xl: 'w-10 h-10 md:w-20 md:h-20',
  }

  const size = props.blok.iconSize
  // eslint-disable-next-line dot-notation
  return classes[size] || classes['md']
})
</script>
